import React from 'react';
import './PlanFeaturesConfig.css';

const PlanFeaturesConfig = ({ features, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...features, [field]: value });
  };

  return (
    <div className="plan-features-config">
      {/* Limites Gerais */}
      <div className="features-section">
        <h3>📊 Limites Gerais</h3>
        <div className="form-row">
          <div className="form-group">
            <label>Grupos que pode participar</label>
            <input
              type="number"
              value={features.max_groups_join || 5}
              onChange={(e) => handleChange('max_groups_join', parseInt(e.target.value))}
              min="0"
            />
          </div>
          <div className="form-group">
            <label>Desafios simultâneos</label>
            <input
              type="number"
              value={features.max_challenges_active || 10}
              onChange={(e) => handleChange('max_challenges_active', parseInt(e.target.value))}
              min="0"
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Entradas no diário (-1 = ilimitado)</label>
            <input
              type="number"
              value={features.max_diary_entries ?? -1}
              onChange={(e) => handleChange('max_diary_entries', parseInt(e.target.value))}
            />
          </div>
          <div className="form-group">
            <label>Armazenamento (MB)</label>
            <input
              type="number"
              value={features.storage_limit_mb || 100}
              onChange={(e) => handleChange('storage_limit_mb', parseInt(e.target.value))}
              min="0"
            />
          </div>
        </div>
      </div>

      {/* Comunidade */}
      <div className="features-section">
        <h3>👥 Comunidade</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_create_groups || false}
              onChange={(e) => handleChange('can_create_groups', e.target.checked)}
            />
            <span>Pode criar grupos próprios</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_create_forum_posts !== false}
              onChange={(e) => handleChange('can_create_forum_posts', e.target.checked)}
            />
            <span>Pode postar no fórum</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_send_private_msg !== false}
              onChange={(e) => handleChange('can_send_private_msg', e.target.checked)}
            />
            <span>Mensagens privadas habilitadas</span>
          </label>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Posts em grupos/dia</label>
            <input
              type="number"
              value={features.max_group_posts_day || 10}
              onChange={(e) => handleChange('max_group_posts_day', parseInt(e.target.value))}
              min="0"
            />
          </div>
          <div className="form-group">
            <label>Posts no fórum/dia</label>
            <input
              type="number"
              value={features.max_forum_posts_day || 5}
              onChange={(e) => handleChange('max_forum_posts_day', parseInt(e.target.value))}
              min="0"
            />
          </div>
        </div>
        <div className="form-group">
          <label>Mensagens privadas/dia</label>
          <input
            type="number"
            value={features.max_private_msg_day || 20}
            onChange={(e) => handleChange('max_private_msg_day', parseInt(e.target.value))}
            min="0"
          />
        </div>
      </div>

      {/* Conteúdo */}
      <div className="features-section">
        <h3>📚 Conteúdo Educativo</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_access_premium_content || false}
              onChange={(e) => handleChange('can_access_premium_content', e.target.checked)}
            />
            <span>Acesso a conteúdo premium</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_download_content || false}
              onChange={(e) => handleChange('can_download_content', e.target.checked)}
            />
            <span>Download de conteúdo</span>
          </label>
        </div>
        <div className="form-group">
          <label>Downloads de conteúdo/mês</label>
          <input
            type="number"
            value={features.max_content_downloads || 0}
            onChange={(e) => handleChange('max_content_downloads', parseInt(e.target.value))}
            min="0"
          />
        </div>
      </div>

      {/* Meditação */}
      <div className="features-section">
        <h3>🧘 Meditação</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_access_meditation !== false}
              onChange={(e) => handleChange('can_access_meditation', e.target.checked)}
            />
            <span>Acesso a meditações</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_access_premium_meditation || false}
              onChange={(e) => handleChange('can_access_premium_meditation', e.target.checked)}
            />
            <span>Meditações premium</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_download_meditation || false}
              onChange={(e) => handleChange('can_download_meditation', e.target.checked)}
            />
            <span>Download de meditações (offline)</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.meditation_ad_free || false}
              onChange={(e) => handleChange('meditation_ad_free', e.target.checked)}
            />
            <span>Meditação sem anúncios</span>
          </label>
        </div>
        <div className="form-group">
          <label>Downloads de meditação</label>
          <input
            type="number"
            value={features.max_meditation_downloads || 0}
            onChange={(e) => handleChange('max_meditation_downloads', parseInt(e.target.value))}
            min="0"
          />
        </div>
      </div>

      {/* Gamificação */}
      <div className="features-section">
        <h3>🎮 Gamificação</h3>
        <div className="form-group">
          <label>Multiplicador de pontos</label>
          <input
            type="number"
            step="0.1"
            value={features.earn_points_multiplier || 1.0}
            onChange={(e) => handleChange('earn_points_multiplier', parseFloat(e.target.value))}
            min="0.1"
            max="10"
          />
          <small className="form-hint">1.0 = normal, 2.0 = dobro de pontos</small>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_access_leaderboard !== false}
              onChange={(e) => handleChange('can_access_leaderboard', e.target.checked)}
            />
            <span>Pode ver ranking</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_appear_leaderboard !== false}
              onChange={(e) => handleChange('can_appear_leaderboard', e.target.checked)}
            />
            <span>Aparece no ranking</span>
          </label>
        </div>
        <div className="form-group">
          <label>Conquistas desbloqueáveis (-1 = ilimitado)</label>
          <input
            type="number"
            value={features.max_achievements_unlock ?? -1}
            onChange={(e) => handleChange('max_achievements_unlock', parseInt(e.target.value))}
          />
        </div>
      </div>

      {/* Analytics */}
      <div className="features-section">
        <h3>📈 Progresso & Analytics</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.advanced_analytics || false}
              onChange={(e) => handleChange('advanced_analytics', e.target.checked)}
            />
            <span>Analytics avançado</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.can_export_data !== false}
              onChange={(e) => handleChange('can_export_data', e.target.checked)}
            />
            <span>Exportar dados pessoais</span>
          </label>
        </div>
        <div className="form-group">
          <label>Retenção de dados (dias)</label>
          <input
            type="number"
            value={features.data_retention_days || 365}
            onChange={(e) => handleChange('data_retention_days', parseInt(e.target.value))}
            min="30"
          />
        </div>
      </div>

      {/* Suporte & Extras */}
      <div className="features-section">
        <h3>💎 Suporte & Extras</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.priority_support || false}
              onChange={(e) => handleChange('priority_support', e.target.checked)}
            />
            <span>Suporte prioritário</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.ai_chat_enabled || false}
              onChange={(e) => handleChange('ai_chat_enabled', e.target.checked)}
            />
            <span>Chat com IA habilitado</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.custom_themes || false}
              onChange={(e) => handleChange('custom_themes', e.target.checked)}
            />
            <span>Temas personalizados</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.ad_free_experience || false}
              onChange={(e) => handleChange('ad_free_experience', e.target.checked)}
            />
            <span>Experiência sem anúncios</span>
          </label>
        </div>
        <div className="form-group">
          <label>Mensagens com IA/mês</label>
          <input
            type="number"
            value={features.ai_messages_limit || 0}
            onChange={(e) => handleChange('ai_messages_limit', parseInt(e.target.value))}
            min="0"
          />
        </div>
      </div>

      {/* Bloqueador */}
      <div className="features-section">
        <h3>🛡️ Bloqueador de Conteúdo</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.content_blocker_enabled !== false}
              onChange={(e) => handleChange('content_blocker_enabled', e.target.checked)}
            />
            <span>Bloqueador básico</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.advanced_blocker || false}
              onChange={(e) => handleChange('advanced_blocker', e.target.checked)}
            />
            <span>Bloqueador avançado</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.custom_blocklist || false}
              onChange={(e) => handleChange('custom_blocklist', e.target.checked)}
            />
            <span>Lista personalizada de bloqueios</span>
          </label>
        </div>
      </div>

      {/* Sistema de Emergência */}
      <div className="features-section">
        <h3>🚨 Sistema de Emergência</h3>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.emergency_sms_enabled || false}
              onChange={(e) => handleChange('emergency_sms_enabled', e.target.checked)}
            />
            <span>SMS de emergência</span>
          </label>
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={features.emergency_call_enabled || false}
              onChange={(e) => handleChange('emergency_call_enabled', e.target.checked)}
            />
            <span>Ligação de emergência</span>
          </label>
        </div>
        <div className="form-group">
          <label>Contatos de emergência</label>
          <input
            type="number"
            value={features.max_emergency_contacts || 3}
            onChange={(e) => handleChange('max_emergency_contacts', parseInt(e.target.value))}
            min="0"
            max="10"
          />
        </div>
      </div>
    </div>
  );
};

export default PlanFeaturesConfig;
